// FILE: client/src/screens/AdminCreditsScreen.js
import React, { useEffect } from "react";
import { Container, Table, Row, Col, Button, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";
import Message from "../../components/Message";
import {
  listCreditsAdmin,
  deleteCreditBlock,
} from "../../actions/creditActions";
import { CREDIT_DELETE_RESET } from "../../constants/creditConstants";

export default function AdminCreditsScreen() {
  const dispatch = useDispatch();

  const adminList = useSelector((state) => state.creditsAdminList);
  const { loading, error, blocks = [] } = adminList;

  const deleted = useSelector((state) => state.creditsDelete);
  const { success: successDelete, error: deleteError } = deleted;

  useEffect(() => {
    dispatch(listCreditsAdmin());
  }, [dispatch, successDelete]);

  useEffect(() => {
    if (successDelete) dispatch({ type: CREDIT_DELETE_RESET });
  }, [successDelete, dispatch]);

  const deleteHandler = (id) => {
    if (window.confirm("Delete this credit block? (soft delete)")) {
      dispatch(deleteCreditBlock(id));
    }
  };

  return (
    <Container className="py-4">
      <Row className="align-items-center g-3 mb-3">
        <Col>
          <h1>Admin • Credits</h1>
          <div className="text-muted">
            Manage credits blocks shown on /credits
          </div>
        </Col>
        <Col md="auto">
          <Link to="/admin/credits/new" className="btn btn-dark">
            Create block
          </Link>
        </Col>
      </Row>

      {deleteError && <Message variant="danger">{deleteError}</Message>}
      {error && <Message variant="danger">{error}</Message>}
      {loading && <Loader />}

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Order</th>
            <th>Label</th>
            <th>Items</th>
            <th>Status</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>

        <tbody>
          {blocks.map((b) => (
            <tr key={b._id} style={b.isDeleted ? { opacity: 0.6 } : undefined}>
              <td>{b.order}</td>
              <td>
                {b.label}{" "}
                {b.isDeleted && (
                  <Badge bg="secondary" className="ms-2">
                    Deleted
                  </Badge>
                )}
              </td>
              <td>{(b.items || []).length}</td>
              <td>
                {b.isPublished ? (
                  <Badge bg="success">Published</Badge>
                ) : (
                  <Badge bg="warning" text="dark">
                    Unpublished
                  </Badge>
                )}
              </td>
              <td>
                <Link to={`/admin/credits/${b._id}`}>Edit</Link>
              </td>
              <td>
                <Button
                  variant="outline-danger"
                  size="sm"
                  disabled={b.isDeleted}
                  onClick={() => deleteHandler(b._id)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}

          {blocks.length === 0 && (
            <tr>
              <td colSpan={6} className="text-center text-muted">
                No credit blocks
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
}
